import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const LinkBehavior = React.forwardRef((props, ref) => {
  const { href, ...other } = props;
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

// Create a theme instance.
let theme = createTheme({
  palette: {
    primary: {
      main: "#1c2e6a",
    },
    secondary: {
      main: "#f25764",
    },
    error: {
      main: red.A400,
    },
    info: {
      main: "#b5e5f3",
    },
    divider: "rgba(51,51,51,0.33)",
    background: {
      default: "#f0f1f4",
    },
  },
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
  shape: {
    borderRadius: 6,
  },
  breakpoints: {
    values: {
      xxs: 0,
      xs: 450,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
      styleOverrides: {
        root: {
          color: "unset",
          ":hover": {
            color: "#f25764",
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
